import { memberDetail } from "src/DAL/Profile/Profile";

// The member's profile (api/member/profile) as one React Query entry, shared by the sidebar and the
// dashboard: the dashboard reuses the sidebar's request instead of sending the same one again.
// "all" (or no programme) asks for every programme, as before.
const MEMBER_DATA_STALE_MS = 30 * 1000;

export const memberDataQuery = (programId = "all") => ({
  queryKey: ["memberData", programId],
  queryFn: async () => {
    const result = await memberDetail(programId !== "all" ? programId : "");
    if (result.code === 200) return { ...result, ...result?.member };
    throw new Error(result.message);
  },
  // Fresh for a moment, so the sidebar's fetchQuery reuses the dashboard's answer; the dashboard
  // itself still reloads it on every visit (the app's refetchOnMount "always").
  staleTime: MEMBER_DATA_STALE_MS,
});
